import { render } from "./DownloadView.vue?vue&type=template&id=95d4f892"
import script from "./DownloadView.vue?vue&type=script&lang=js"
export * from "./DownloadView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__